module.exports = __webpack_public_path__ + "static/media/plus.c1211dbc.svg";